/**
 * Private finance documents (2 Nov 2026): finance papers live in a private bucket and their links are
 * on the Link server, `<api>/finance/documents/<key>`. Opening such a link by hand works through the
 * sign-in cookie; a page that reads the file itself (the e-invoice QR reader, downloads) asks for the
 * bytes with its sign-in token instead, since the browser does not send the cookie to a fetch.
 */
export const FINANCE_DOCUMENT_PATH = '/finance/documents/';

export function isPrivateDocument(url: string): boolean {
  return typeof url === 'string' && url.split(/[?#]/)[0].includes(FINANCE_DOCUMENT_PATH);
}

/** Fetches a file the page reads itself: a private finance document through the server, anything else as before. */
export function fetchDocument(url: string): Promise<Response> {
  if (!isPrivateDocument(url)) return fetch(url, { mode: 'cors' });
  const raw = `${url.split('#')[0]}${url.includes('?') ? '&' : '?'}raw=1`;
  return fetch(raw, {
    mode: 'cors',
    headers: { Authorization: `Bearer ${localStorage.getItem('guestToken') || ''}` },
  });
}
